import { RequestObj as RO } from './utils';

export const GET_ORGANIZATION: RO = { method: 'get', url: 'organizations/{orgId}' };

export const POST_IMAGE_DELETE: RO = { method: 'post', url: 'media/delete' };

export const LOGOUT: RO = { method: 'post', url: 'auth/logout' };

export const GET_ME: RO = { method: 'get', url: 'me' };

// Reference Lists
export const GET_REFERENCE_LISTS: RO = { method: 'get', url: 'referenceLists' };

// Integrations
export const SHORTEN_URL_VIA_GLOO_API: RO = { method: 'post', url: 'shortenedUrls' };

// Discover
export const GET_FEATURED_DISCOVER_ITEMS: RO = { method: 'get', url: 'discover/featured-items' };
export const SET_FEATURED_DISCOVER_ITEMS: RO = { method: 'post', url: 'discover/featured-items' };

// Hub
export const GET_HUBS: RO = { method: 'get', url: 'hubs' };
export const GET_HUB: RO = { method: 'get', url: 'hubs/{hubId}' };
export const CREATE_HUB: RO = { method: 'post', url: 'hubs' };
export const UPDATE_HUB: RO = { method: 'put', url: 'hubs/{hubId}' };
export const ARCHIVE_HUB: RO = { method: 'put', url: 'hubs/{hubId}/archive' };
export const GET_ARCHIVED_HUBS: RO = { method: 'get', url: 'hubs/archived' };
export const UNARCHIVE_HUB: RO = { method: 'put', url: 'hubs/{hubId}/unarchive' };

// Kit
export const GET_KITS: RO = { method: 'get', url: 'kits' };
export const CREATE_KIT: RO = { method: 'post', url: 'kits' };
export const GET_KIT: RO = { method: 'get', url: 'kits/{kitId}' };
export const UPDATE_KIT: RO = { method: 'put', url: 'kits/{kitId}' };
export const GET_ARCHIVED_KITS: RO = { method: 'get', url: 'kits/archived' };
export const ARCHIVE_KIT: RO = { method: 'put', url: 'kits/{kitId}/archive' };
export const UNARCHIVE_KIT: RO = { method: 'put', url: 'kits/{kitId}/unarchive' };
export const GET_KIT_PARENTS: RO = { method: 'get', url: 'kits/{kitId}/parents' };

// Template
export const GET_TEMPLATES: RO = { method: 'get', url: 'templates' };
export const CREATE_TEMPLATE: RO = { method: 'post', url: 'templates' };
export const GET_ARCHIVED_TEMPLATES: RO = { method: 'get', url: 'templates/archived' };
export const GET_TEMPLATE: RO = { method: 'get', url: 'templates/{templateId}' };
export const UPDATE_TEMPLATE: RO = { method: 'put', url: 'templates/{templateId}' };
export const ARCHIVE_TEMPLATE: RO = { method: 'put', url: 'templates/{templateId}/archive' };
export const UNARCHIVE_TEMPLATE: RO = { method: 'put', url: 'templates/{templateId}/unarchive' };
export const GET_TEMPLATE_PARENTS: RO = { method: 'get', url: 'templates/{templateId}/parents' };

// Conversation Prompts
export const GET_CONVERSATION_PROMPT: RO = { method: 'get', url: 'conversation-prompts/{id}' };
export const QUERY_CONVERSATION_PROMPTS: RO = { method: 'post', url: 'conversation-prompts/search' };
export const GET_ALL_CONVERSATION_PROMPT_AUTHORS: RO = { method: 'get', url: 'conversation-prompts/authors' };
export const UPDATE_CONVERSATION_PROMPT: RO = { method: 'put', url: 'conversation-prompts/{id}' };
export const CREATE_CONVERSATION_PROMPT: RO = { method: 'post', url: 'conversation-prompts' };
export const GET_ALL_SUGGESTED_TOPICS: RO = { method: 'get', url: 'conversation-prompts/suggestedTopics' };
